import axios from "axios";
import { API_URI } from ".";

const http = axios.create({
  baseURL: API_URI,
});

// Add response interceptor to handle 401 errors
http.interceptors.response.use(
  (response) => {
    // Return successful responses as-is
    return response;
  },
  (error) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Don't redirect on login endpoint (401 is a legitimate error there)
      const isLoginEndpoint = error.config?.url?.includes('/v1/auth/token');
      
      if (!isLoginEndpoint) {
        // Clear authentication data
        localStorage.removeItem("token");
        localStorage.removeItem("role");
        
        // Redirect to login page
        window.location.href = '/login';
      }
    }
    
    // Return the error so it can be handled by the calling code
    return Promise.reject(error);
  }
);

export default http;